import { config } from "../../config";

export const getImageUrl = (imageKey: string): string => {
  return `${config.uploadRoot}/${imageKey}`;
};
